import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  padding: ${({ theme }) => theme.commons.card.padding};
  margin: ${({ theme }) => theme.commons.card.margin};
  border: ${({ theme }) =>
    `1px solid ${theme.color('shape-color-stroke-primary')}`};

  border-radius: ${({ theme }) => theme.commons.card.borderRadius};
  ${({ transparent }) =>
    !transparent &&
    css`
      background: ${({ theme }) => theme.commons.card.background};
      box-shadow: ${({ theme }) => theme.commons.card.elevation};
    `}
`;
Card.propTypes = {
  direction: PropTypes.oneOf(['row', 'column']),
  transparent: PropTypes.bool,
};

Card.defaultProps = {
  direction: 'row',
};

export default Card;
